const headerData = [{
		prop: "id",
		label: "序号",
		columnwidth: 50,
	},
	{
		prop: "StatusName",
		label: "状态",
		columnwidth: 90,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 120,
	},
	{
		prop: "RejectReason",
		label: "驳回原因",
		columnwidth: 150,
	},
	{
		prop: "ApplyReason",
		label: "申请理由",
		columnwidth: 200,
	},
	{
		prop: "Year",
		label: "年份",
		columnwidth: 100,
	},
	{
		prop: "CusName",
		label: "经销商",
		columnwidth: 200,
	},
	{
		prop: "YearQuota",
		label: "总指标",
		columnwidth: 100,
	},
	{
		prop: "OrgName",
		label: "原经销商",
		columnwidth: 200,
	},
	// {
	//   prop: "YearQuota",
	//   label: "备注",
	//   columnwidth: 200,
	// },
	{
		prop: "NeedBossApprovalName",
		label: "是否需要高层审批",
		columnwidth: 130,
	},
	{
		prop: "LEVEL1_5",
		label: "LEVEL1.5",
		columnwidth: 150,
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 150,
	},
	{
		prop: "RejecterName",
		label: "驳回人",
		columnwidth: 150,
	},
	{
		prop: "CreateName",
		label: "创建人",
		columnwidth: 150,
	},
	{
		prop: "RejectTime",
		label: "驳回时间",
		columnwidth: 150,
	},
];
export default headerData